module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/six_band-fb849c.png";